import { basePath } from "@Common/constants";
import { resourcesNamesStandard } from "@Common/types/resources";
import { authProvider } from "@Src/authProvider";
import { RetrowaveBackground } from "@Src/components/RetrowaveBackground";
import { letsgoPath, thanksResponsesPath } from "@Src/constants";
import { PublicKeyProvider } from "@Src/contexts/PublicKeyContext";
import { PublicModeProvider } from "@Src/contexts/PublicModeContext";
import { customDataProvider } from "@Src/dataProvider";
import { Layout } from "@Src/layout";
import { Login } from "@Src/layout/Login";
import { AboutPage } from "@Src/pages/AboutPage";
import { BravoPage } from "@Src/pages/Bravo";
import { ContactPage } from "@Src/pages/ContactPage";
import { ErrorPage } from "@Src/pages/ErrorPage";
import { FeaturesPage } from "@Src/pages/FeaturesPage";
import { LetsgoPage } from "@Src/pages/Letsgo";
import { PricingPage } from "@Src/pages/PricingPage";
import { PrivacyPage } from "@Src/pages/PrivacyPage";
import { PublicHomepage } from "@Src/pages/PublicHomepage";
import { TermsPage } from "@Src/pages/TermsPage";
import { ThanksResponsesPages } from "@Src/pages/ThanksResponses";
import { resourcesStandard } from "@Src/resources/resources_config";
import { softLightTheme } from "@Src/themes/softTheme";
import { type ThemeName, themes } from "@Src/themes/themes";
import { ThemeProvider } from "@mui/material";
import {
	Admin,
	CustomRoutes,
	localStorageStore,
	Resource,
	useStore,
} from "react-admin";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const store = localStorageStore(undefined, "NoMachine");

const AdminApp = () => {
	const [themeName] = useStore<ThemeName>("themeName", "soft");
	const theme = themes.find((th) => th.name === themeName);
	if (!theme) {
		throw Error("Theme should not be undefined");
	}
	const lightTheme = theme.light;
	const darkTheme = theme.dark;

	return (
		<Admin
			basename={basePath}
			store={store}
			dataProvider={customDataProvider}
			loginPage={<Login context="magic_link" />}
			authProvider={authProvider}
			layout={Layout}
			lightTheme={lightTheme}
			darkTheme={darkTheme}
			defaultTheme="light"
			title="nomachine"
		>
			<CustomRoutes noLayout>
				<Route path="/login-bo" element={<Login context="sso" />} />
				<Route path="/bravo" element={<BravoPage />} />
				<Route path={letsgoPath} element={<LetsgoPage />} />
				<Route path={thanksResponsesPath} element={<ThanksResponsesPages />} />
				<Route path="/error" element={<ErrorPage />} />
			</CustomRoutes>
			{resourcesNamesStandard.map((name) => {
				return <Resource key={name} {...resourcesStandard[name].resource} />;
			})}
		</Admin>
	);
};

const App = () => {
	return (
		<PublicKeyProvider>
			<PublicModeProvider>
				<BrowserRouter>
					<ThemeProvider theme={softLightTheme}>
						<Routes>
							<Route path="/" element={<PublicHomepage />} />
							<Route path="/about" element={<AboutPage />} />
							<Route path="/pricing" element={<PricingPage />} />
							<Route path="/features" element={<FeaturesPage />} />
							<Route path="/contact" element={<ContactPage />} />
							<Route path="/privacy" element={<PrivacyPage />} />
							<Route path="/terms" element={<TermsPage />} />
							<Route
								path="/app/*"
								element={
									<>
										<RetrowaveBackground />
										<AdminApp />
									</>
								}
							/>
						</Routes>
					</ThemeProvider>
				</BrowserRouter>
			</PublicModeProvider>
		</PublicKeyProvider>
	);
};
export default App;
